import React, { useState } from 'react';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
// import GoogleIcon from '@mui/icons-material/Google';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  Button,
  Link,
  CircularProgress,
} from '@mui/material';
import { signInWithEmailAndPassword } from 'firebase/auth';

import { auth } from 'services/firebase/client'; // Import Firebase Auth
import Logo from 'assets/icons/logo_transparente_preto.png';
import { cssStyles, sxStyles } from './styles';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string })?.from;

  // Form state
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Handle input changes
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setEmail(e.target.value);
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setPassword(e.target.value);

  // ✅ Handle Email/Password Login
  const handleLogin = async () => {
    setLoading(true);
    setError(null);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate(from || '/', { replace: true });
    } catch (err: any) {
      console.error('Login error:', err);
      setError('Email ou senha inválidos.'); // Show user-friendly error
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle Google Login
  // const handleGoogleLogin = async () => {
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     await signInWithPopup(auth, googleProvider);
  //     navigate('/home'); // Redirect after Google login
  //   } catch (err: any) {
  //     console.error('Google login error:', err);
  //     setError('Erro ao autenticar com Google.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <Box sx={sxStyles.mainContainer}>
      <Card sx={sxStyles.card}>
        <CardContent>
          {/* Logo */}
          <Box sx={{ textAlign: 'center' }}>
            <img
              src={Logo}
              alt="Logo Clube da 42"
              style={cssStyles.logoStyle}
            />
          </Box>

          {/* Welcome Text */}
          <Typography variant="h5" sx={sxStyles.welcomeText}>
            Bem-vindo ao Clube da 42
          </Typography>

          {/* Login Form */}
          <Box component="form" noValidate sx={{ mt: 3 }}>
            <TextField
              fullWidth
              label="E-mail"
              variant="outlined"
              margin="normal"
              value={email}
              onChange={handleEmailChange}
            />
            <TextField
              fullWidth
              label="Senha"
              type="password"
              variant="outlined"
              margin="normal"
              value={password}
              onChange={handlePasswordChange}
            />

            {error && (
              <Typography color="error" sx={{ mt: 1 }}>
                {error}
              </Typography>
            )}

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 2 }}
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Login'
              )}
            </Button>
          </Box>

          {/* Links Section */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Link
              href="/forgot-password"
              underline="hover"
              variant="body2"
              sx={sxStyles.link}
            >
              Esqueceu sua senha?
            </Link>
            <Link
              component={RouterLink}
              to="/signup"
              state={from ? { from } : undefined}
              underline="hover"
              variant="body2"
              sx={sxStyles.link}
            >
              Cadastre-se
            </Link>
          </Box>

          {/* <Divider sx={sxStyles.divider} /> */}

          {/* SSO Section */}
          {/* <Typography sx={sxStyles.ssoText}>
            Se preferir, faça login utilizando suas redes sociais
          </Typography>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<GoogleIcon />}
            sx={sxStyles.googleButton}
            onClick={handleGoogleLogin}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Login com Google'}
          </Button> */}
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
